import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AyahBunda from "../assets/images/ayah-bunda.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CtaSiKembar = () => {
  const { t } = useTranslation();

  return (
    <section className="cta-si-kembar text-center bg-blue text-white py-0">
      <Container>
        <Row className="d-flex align-items-center text-center" style={{ paddingTop: "2rem" }}>
          <Col lg={2} className="d-none d-lg-block">
            <img src="../assets/images/roboling-chef.svg" alt="Roboling Chef" className="img-fluid roboling-chef" />
          </Col>
          <Col lg={8}>
            <h2 className="mb-4 section-title">{t("cta-si-kembar-title")}</h2>

            <Link to="https://childreams.co.id/" className="btn btn-eclipse" style={{ fontSize: "22px" }}>
              {t("cta-see-product")}
            </Link>
          </Col>
          <Col lg={2} className="d-none d-lg-block">
            <img src={AyahBunda} alt="Ayah Bunda" className="img-fluid ayah-bunda" />
          </Col>

          <Col xs={6} className="d-block d-lg-none">
            <img src="../assets/images/roboling-chef.svg" alt="Roboling Chef" className="img-fluid roboling-chef" />
          </Col>
          <Col xs={6} className="d-block d-lg-none">
            <img src={AyahBunda} alt="Ayah" className="img-fluid ayah-bunda" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CtaSiKembar;
